"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const booleans_1 = require("./booleans");
const expressions_1 = require("./expressions");
const operators_1 = require("./operators");
const question_steps_1 = require("./question-steps");
const text_with_placeholders_1 = require("./text-with-placeholders");
const value_names_list_1 = require("./value-names-list");
const name_value_list_1 = require("./name-value-list");
const tables_1 = require("./tables");
const fns = {
    boolean: booleans_1.boolean,
    evaluateExpression: expressions_1.evaluateExpression,
    evaluateExpressionList: expressions_1.evaluateExpressionList,
    evaluateLatexPlaceholders: text_with_placeholders_1.evaluateLatexPlaceholders,
    evaluateNameValueList: name_value_list_1.evaluateNameValueList,
    evaluatePlaceholders: text_with_placeholders_1.evaluatePlaceholders,
    evaluateTable: tables_1.evaluateTable,
    evaluateTextWithPlaceholdersArray: text_with_placeholders_1.evaluateTextWithPlaceholdersArray,
    evaluateTextWithPlaceholdersTable: text_with_placeholders_1.evaluateTextWithPlaceholdersTable,
    evaluateValueNamesList: value_names_list_1.evaluateValueNamesList,
    operator: operators_1.operator,
    questionSteps: question_steps_1.questionSteps,
    tokeniseString: text_with_placeholders_1.tokeniseString,
};
exports.default = fns;
